// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Menu = React.forwardRef(function Menu(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></SvgIcon>;
});
export default Menu;
